import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AccountClient, UserLoginDTO } from '../models/models.swagger.generated';

@Injectable()
export class LoginProxy {
  constructor(
    private accountClient: AccountClient) {
  }

  public login(userName: string, password: string): Observable<[string, string]> {
    return this.accountClient.token(new UserLoginDTO({userName, password, grant_Type: 'password', client_Id: environment.apiClientId}))
      .pipe(
          map((res: any) => {
              return [res.access_token, res.refresh_token];
          })
    );
  }

  public refreshTokenLogin(refreshToken: string): Observable<[string, string]> {
    return this.accountClient.token(new UserLoginDTO({grant_Type: 'refresh_token', client_Id: environment.apiClientId, refresh_Token: refreshToken}))
      .pipe(
        map((res: any) => {
            return [res.access_token, res.refresh_token];
        })
    );
  }
}
